(function () {
  'use strict';

  // Every marketing CTA on the site points at /products/nked-glp-baddie?view=pdp#nked-buy
  // (the <section class="nked-buybox" id="nked-buy"> subscription block on the PDP).
  //
  // - Not on the PDP  -> let the link navigate; the browser lands on #nked-buy natively.
  // - Already on the PDP -> intercept and smooth-scroll to the top of the buy box.

  var TARGET_ID = 'nked-buy';
  var OFFSET = 20; // keep in sync with .nked-buybox scroll-margin-top

  function scrollToBuybox(smooth) {
    var el = document.getElementById(TARGET_ID);
    if (!el) return false;
    var y = el.getBoundingClientRect().top + window.pageYOffset - OFFSET;
    window.scrollTo({ top: y, behavior: smooth ? 'smooth' : 'auto' });
    return true;
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var link = e.target.closest('a[href*="#' + TARGET_ID + '"]');
    if (!link) return;
    if (!document.getElementById(TARGET_ID)) return; // not on the PDP - let it navigate
    e.preventDefault();
    scrollToBuybox(true);
    if (window.history && history.replaceState) {
      history.replaceState(null, '', '#' + TARGET_ID);
    }
  });

  // Landed on the PDP via ...?view=pdp#nked-buy - re-align once images/layout settle.
  if (window.location.hash === '#' + TARGET_ID) {
    window.addEventListener('load', function () {
      setTimeout(function () { scrollToBuybox(false); }, 60);
    });
  }
})();
